import { BoardIcon, CompassIcon, LayersIcon, TargetIcon, UserIcon, type IconProps } from "./Icons";
import type { AppTab } from "./AppBar";
import type { ComponentType } from "react";

interface BottomNavProps {
  tab: AppTab;
  onTab: (tab: AppTab) => void;
}

const ITEMS: Array<{ id: AppTab; label: string; icon: ComponentType<IconProps> }> = [
  { id: "analyze", label: "Analyze", icon: BoardIcon },
  { id: "train", label: "Train", icon: TargetIcon },
  { id: "explore", label: "Explore", icon: CompassIcon },
  { id: "games", label: "Games", icon: LayersIcon },
  { id: "me", label: "Me", icon: UserIcon },
];

export function BottomNav({ tab, onTab }: BottomNavProps) {
  return (
    <nav className="bottomnav" aria-label="Sections">
      {ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.id}
            className="bottomnav__item"
            onClick={() => onTab(item.id)}
            aria-current={tab === item.id ? "true" : undefined}
          >
            <Icon size={21} />
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
